import React, { useState, useEffect } from "react";
import chevronarriba from "../../assets/chevronarriba.png";
import chevronabajo from "../../assets/chevronabajo.png";
import "./styles.scss";

export default function RoundTabs({ rounds, active, onChange, mobileMenuOpen, onMobileMenuOpenChange }) {
  const [uncontrolledMenuOpen, setUncontrolledMenuOpen] = useState(true);
  const isMenuControlled = mobileMenuOpen !== undefined;
  const menuOpen = isMenuControlled ? mobileMenuOpen : uncontrolledMenuOpen;
  const setMenuOpen = (next) => {
    const value = typeof next === 'function' ? next(menuOpen) : next;
    if (isMenuControlled) {
      onMobileMenuOpenChange?.(value);
      return;
    }
    setUncontrolledMenuOpen(value);
    onMobileMenuOpenChange?.(value);
  };

  useEffect(() => {
    if (isMenuControlled) return undefined;
    onMobileMenuOpenChange?.(menuOpen);
    return undefined;
  }, [isMenuControlled, menuOpen, onMobileMenuOpenChange]);

  return (
    <div className="round-tabs">
      <div className="round-tabs__mobile" aria-label="Selector de ronda (mobile)">
        <div className="round-tabs__mobile-bar">
          <div className="round-tabs__mobile-active">{rounds[active]}</div>
          <button
            type="button"
            className="round-tabs__mobile-chevron"
            onClick={() => setMenuOpen((v) => !v)}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Cerrar rondas" : "Abrir rondas"}
          >
            <img
              style={{ width: 12, height: 7 }}
              src={menuOpen ? chevronarriba : chevronabajo}
              alt=""
            />
          </button>
        </div>
        {menuOpen && (
          <div className="round-tabs__mobile-menu" role="menu" aria-label="Rondas">
            {rounds.map((r, i) => (
              <button
                key={r}
                type="button"
                role="menuitem"
                className={`round-tabs__mobile-option ${active === i ? "round-tabs__mobile-option--active" : ""}`}
                onClick={() => onChange(i)}
              >
                {r}
              </button>
            ))}
          </div>
        )}
      </div>

      {rounds.map((r, i) => (
        <button
          key={r}
          type="button"
          onClick={() => onChange(i)}
          className={`round-tabs__tab ${active === i ? "round-tabs__tab--active" : ""}`}
        >
          {r}
        </button>
      ))}
    </div>
  );
}
